import { InventoryHoldArea } from "../../constants"

import type { FileTypeToChipMap } from "@/components/Tables/Aeros/hooks/useFileColumns"
import {
  FieldGroupEnum,
  TransferReason,
  TransferStatus,
  TransferType,
  WarehousePalletDestinationArea,
} from "@/graphql/codegen/graphql"
import colors from "@/styles/colors"
import type { Option } from "@/types/form-fields"

export { TransferReason, TransferStatus, TransferType }

export const HOLD_AREA_TO_DESTINATION_AREA: Partial<Record<InventoryHoldArea, WarehousePalletDestinationArea>> = {
  [InventoryHoldArea.InboundHold]: WarehousePalletDestinationArea.InboundHold,
  [InventoryHoldArea.OutboundHold]: WarehousePalletDestinationArea.OutboundHold,
  [InventoryHoldArea.OffSpecArea]: WarehousePalletDestinationArea.OffSpec,
}

export const TRANSFER_TYPE_TO_LABEL: Record<TransferType, string> = {
  [TransferType.IntraWarehouse]: "Intra Warehouse Transfer",
  [TransferType.InterWarehouse]: "Inter Warehouse Transfer",
} as const

export const TRANSFER_TYPE_OPTIONS: Option<TransferType>[] = [
  { value: TransferType.IntraWarehouse, label: TRANSFER_TYPE_TO_LABEL[TransferType.IntraWarehouse] },
]

export const TRANSFER_TYPE_TO_SHORT_LABEL: Record<TransferType, string> = {
  [TransferType.IntraWarehouse]: "Intra",
  [TransferType.InterWarehouse]: "Inter",
} as const

export const TRANSFER_STATUS_TO_LABEL: Record<TransferStatus, string> = {
  [TransferStatus.Draft]: "Draft",
  [TransferStatus.PendingPickAndPutaway]: "Pending Pick and Putaway",
  [TransferStatus.Completed]: "Completed",
  [TransferStatus.Cancelled]: "Cancelled",
} as const

export const TRANSFER_FILTERABLE_STATUSES: TransferStatus[] = Object.values(TransferStatus).filter(
  (status) => status !== TransferStatus.Cancelled
)

export enum TransferActionType {
  Edit = "EDIT",
  WorkOrderConfirm = "WORK_ORDER_CONFIRM",
  WorkOrderPrint = "WORK_ORDER_PRINT",
  Cancel = "CANCEL",
  PalletLabelPrint = "PALLET_LABEL_PRINT",
  DocumentsView = "DOCUMENTS_VIEW",
}

export const TRANSFER_REASON_OPTIONS: Option<string>[] = [
  { value: TransferReason.Replenishment, label: "Replenishment" },
  { value: TransferReason.QualityIssue, label: "Quality Issue" },
  { value: TransferReason.LocationOptimization, label: "Location Optimization" },
  { value: TransferReason.InventoryRebalancing, label: "Inventory Rebalancing" },
  { value: TransferReason.DamagedGoods, label: "Damaged Goods" },
  { value: TransferReason.ProductConsolidation, label: "Product Consolidation" },
]

export const TRANSFER_DOCUMENT_TYPE_TO_CHIP: FileTypeToChipMap = {
  [FieldGroupEnum.Transfer]: { label: "Transfer", color: colors.primary["200"] },
}
